import { useQuery } from '@tanstack/react-query';

import { accountUserDetailKey } from '../common/queryKeys';
import AccountUserApi from '../../../../../lib/api/account/user/AccountUserApi';
import { setRequestForm } from '../../../../../lib/common';
import {
  ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LIST_FILER_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LIST_SORT_OPTION_MODEL,
  ACCOUNT_USER_LIKE_PRODUCT_DETAIL_MODEL,
  ACCOUNT_USER_LIKE_PRODUCT_LIST_MODEL,
  ACCOUNT_USER_LIKE_PRODUCT_LOG_LIST_MODEL,
} from './models';

export const useAccountUserLikeProductDetailQuery = ({ userId, options }) => {
  return useQuery(
    [...accountUserDetailKey, 'likeProduct', 'detail', userId],
    async () => {
      const result = await AccountUserApi.getAccountUserLikeProductDetail(
        setRequestForm(
          {
            userId,
            likeProductHistory: {
              filterOption: ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LIST_FILER_OPTION_MODEL,
              sortOption: ACCOUNT_USER_DETAIL_LIKE_PRODUCT_LIST_SORT_OPTION_MODEL,
            },
          },
          true,
        ),
      );
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: {
        data: {
          likeProductSummaryData: ACCOUNT_USER_LIKE_PRODUCT_DETAIL_MODEL,
        },
      },
    },
  );
};

export const useAccountUserDetailLikeProductListQuery = ({ userId, pagination, filterOption, sortOption, options }) => {
  return useQuery(
    [...accountUserDetailKey, 'likeProduct', 'list', pagination, filterOption, sortOption, userId],
    async () => {
      const result = await AccountUserApi.getAccountUserDetailLikeProductList(
        setRequestForm({ userId, likeProductHistory: { filterOption, pagination, sortOption } }, true),
      );
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: {
        data: {
          likeProductHistory: ACCOUNT_USER_LIKE_PRODUCT_LIST_MODEL,
        },
      },
    },
  );
};

export const useAccountUserDetailLikeProductLogListQuery = ({
  userId,
  pagination,
  filterOption,
  sortOption,
  actionLogType,
  options,
}) => {
  return useQuery(
    [...accountUserDetailKey, 'likeProduct', 'logList', pagination, filterOption, sortOption, actionLogType, userId],
    async () => {
      const result = await AccountUserApi.getAccountUserDetailLikeProductLogList(
        setRequestForm(
          {
            userId,
            likeProductLogHistory: { filterOption: { ...filterOption, actionLogType }, pagination, sortOption },
          },
          true,
        ),
      );
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: {
        data: ACCOUNT_USER_LIKE_PRODUCT_LOG_LIST_MODEL,
      },
    },
  );
};
